<template>
  <div>
    <UserView01 />
    <ForLink class="mt20 mb20" ref="forLink" :queryRang="4" />
  </div>
</template>

<script>
import UserView01 from "@/components/statistical/user/UserView01";
import ForLink from "@/components/statistical/ForLink";

export default {
  name: "User",
  components: {
    UserView01,
    ForLink
  },
  props: [],
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
